/**
 * The photo views a row may be tagged with (mirrors backend ProductMediaViews.PHOTO_VIEWS). No imports, so
 * the upload queue and previewMedia can share it without a cycle through mediaViews.
 */
export const PHOTO_VIEWS = ["FULL", "PALLU", "BORDER", "BLOUSE", "BACK", "DETAIL"] as const;
export type PhotoView = (typeof PHOTO_VIEWS)[number];

/** A known photo view, upper-cased; anything else (blank, VIDEO, a typo) is null, so it is never sent. */
export const normalizeView = (raw: unknown): PhotoView | null => {
  const view = String(raw || "").trim().toUpperCase();
  return (PHOTO_VIEWS as readonly string[]).includes(view) ? (view as PhotoView) : null;
};
